import { useEffect, useRef, useState } from "react";
import styles from "../Filters.module.scss";
import { ChevronRight, X } from "react-feather";
import { SearchInput } from "@components/templates/SearchInput";
import ReactCountryFlag from "react-country-flag";
import { filterLabel } from "@core/dictionary/filter-type";
export const MulitpleFilter = ({ filterData, payload, onChangeHandler, isDisabled, pendoEventHandler }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [showOptions, setshowOptions] = useState("");
  const [search, setSearch] = useState("");
  const [filterCount, setFilterCount] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  useEffect(() => {
    let count = 0;
    if (payload && payload?.filters) {
      Object.values(payload.filters).map((filterItem) => {
        if (filterItem.length > 0) {
          count = count + filterItem.length;
        }
      });
      setFilterCount(count);
    }
  }, [payload]);

  const handleClickOutside = (e) => {
    if (showFilter && !divRef?.current?.contains(e.target)) {
      setShowFilter(false);
      setshowOptions("");
    }
  };

  const onSearchHandler = (value) => {
    setSearch(value);
  };

  return (
    <div ref={divRef} className="position-relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowFilter(true);
        }}
        className={styles.filterButton}>
        <span className="material-symbols-outlined">tune</span>
        <span className="ml-1 tw-flex">
          Filters
          {filterCount > 0 ? (
            <span className={`ml-2 ${styles.filter_count}`}>
              {filterCount}
              <X
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onChangeHandler("", "", "clearAll");
                }}
                size={16}
              />
            </span>
          ) : (
            <></>
          )}
        </span>
      </button>
      <div className="postion-absolute">
        {showFilter ? (
          <div onClick={(e) => e.stopPropagation()} className={styles.multipleFilterContainer}>
            {filterData &&
              Object.keys(filterData)?.length &&
              Object.keys(filterData).map((option) => (
                <div
                  key={option}
                  onClick={() => {
                    setshowOptions(option);
                    setSearch("");
                    if (pendoEventHandler) {
                      pendoEventHandler(option);
                    }
                  }}
                  className={`${styles.multiOptionsContainer} ${showOptions === option ? styles.activeOption : ""}`}>
                  <label className="m-0 text-capitalize">
                    {Object.entries(filterLabel).map(([key, value]) => {
                      if (key === option) {
                        return value;
                      }
                      return null;
                    })}
                  </label>
                  <span className="tw-flex">
                    {payload?.filters?.[option]?.length ? (
                      <span className={`mr-2 ${styles.filter_count}`}>
                        {payload.filters[option].length}
                        <X
                          onClick={(e) => {
                            e.stopPropagation();
                            onChangeHandler(option, "", "clear");
                          }}
                          className="cursor-pointer tw-mt-[1px]"
                          size={16}
                        />
                      </span>
                    ) : (
                      <></>
                    )}
                    <ChevronRight size={18} color="#667085" />
                  </span>
                </div>
              ))}
          </div>
        ) : (
          ""
        )}
      </div>
      {showOptions ? (
        <div onClick={(e) => e.stopPropagation()} className={`${styles.singleFilterContainer} ${styles.innerFilterContainer}`}>
          {(payload?.type === "company" || payload?.type === "logistics") && filterData[showOptions]?.length < 5 ? (
            ""
          ) : (
            <div className="mb-2">
              <SearchInput value={search} onSearchHandler={onSearchHandler} />
            </div>
          )}
          {filterData[showOptions] &&
            filterData[showOptions].map((filter, index) => {
              if (typeof filter === "string" && filter.toLowerCase().includes(search.toLowerCase())) {
                return (
                  <label key={filter} className="form-check ml-2">
                    <input disabled={isDisabled} className="form-check-input" onChange={() => onChangeHandler(showOptions, filter)} checked={payload.filters[showOptions]?.includes(filter)} type="checkbox" id={`checkbox${index}`} />
                    <span className="form-check-label" htmlFor={`checkbox${index}`}>
                      {filter}
                    </span>
                  </label>
                );
              } else if (typeof filter === "object" && filter?.key && filter.key.toLowerCase().includes(search.toLowerCase())) {
                return (
                  <div key={filter.key} className={`${styles.custom_input} mb-3 mt-2 d-flex align-items-center`}>
                    <input onChange={() => onChangeHandler(showOptions, filter)} checked={payload.filters[showOptions]?.includes(filter.key)} type="checkbox" id={`checkbox${index}`} />
                    <label className={styles.filterLabel} htmlFor={`checkbox${index}`}>
                      {/* {filter.country_code ? titleCaseDataSource(filter.key) : filter.key} */}
                      <span className="text-capitalize">{filter.key}</span>
                      {filter.country_code && <ReactCountryFlag className="ml-1" countryCode={filter.country_code} svg />}
                    </label>
                  </div>
                );
              }
            })}
        </div>
      ) : null}
    </div>
  );
};
